import React from "react";

import { convertWind, friendlyWindUnitName } from "../util/util";
import UnicodeSmileyFont from "./UnicodeSmiley";

type WindUnits = string;

interface Props {
  windUnits: WindUnits;
}

interface SmileyRow {
  smileys: string;
  range: [number, number]; // in half-knots
  description: string;
}

const smileyData: SmileyRow[] = [
  {
    smileys: "⚠️⚠️🏴‍☠️",
    range: [-6, -5.5],
    description: "Ga gewoon iets anders doen...",
  },
  {
    smileys: "⚠️⚠️⚠️",
    range: [-5.5, -4.5],
    description:
      "Komt (bijna) niet voor in Nederland. Dit is wel echt een slecht moment om het water op te gaan.",
  },
  {
    smileys: "😭⚠️",
    range: [-4.5, -3.5],
    description: "Zelfs op een hydrofoil niet meer leuk",
  },
  {
    smileys: "😫",
    range: [-3.5, -2.5],
    description:
      "Vervelend. Twintippers stoppen ermee omdat ze alleen nog bezig zijn met hoogte lopen (als dat al lukt)",
  },
  {
    smileys: "😟",
    range: [-2.5, -1.5],
    description: "Begint irritant te worden",
  },
  {
    smileys: "😕",
    range: [-1.5, -0.5],
    description: "De stroming is merkbaar, maar niet echt vervelend",
  },
  {
    smileys: "",
    range: [-0.5, 0.5],
    description: "Neutrale stroming, geen bijzonder effect",
  },
  {
    smileys: "🙂",
    range: [0.5, 1.5],
    description:
      "De stroming is merkbaar, maar je hebt er nou ook weer niet heel veel aan.",
  },
  {
    smileys: "😀",
    range: [1.5, 2.5],
    description: "Gratis hoogte lopen. Leuk voor iedereen!",
  },
  {
    smileys: "😁🤙",
    range: [2.5, 3.5],
    description: "Leuk in licht weer. Je kunt een in-place downwinder doen! 😀",
  },
  {
    smileys: "😁🤙⚠️",
    range: [3.5, 4.5],
    description:
      "Super vet voor kiteloopers. Anderen moeten (met de wind mee!!) teruglopen of wel heel vaak springen.",
  },
  {
    smileys: "😬🤙⚠️",
    range: [4.5, 5.5],
    description:
      "Komt (bijna) niet voor in nederland. Waarschijnlijk een beetje veel van het goede.",
  },
  {
    smileys: "😬⚠️⚠️",
    range: [5.5, 6],
    description:
      "In uitzonderlijke gevallen misschien leuk, maar waarschijnlijk vooral gewoon gevaarlijk.",
  },
];

const SmileyStromingTable: React.FC<Props> = ({ windUnits }) => {
  const unitName = friendlyWindUnitName(windUnits);

  const toConvertedString = (halfKnot: number): string => {
    const ms = halfKnot * 0.257222;
    return convertWind(ms, windUnits, 1).toFixed(1);
  };

  return (
    <div style={{ overflowX: "auto" }}>
      <table style={{ borderCollapse: "collapse", width: "100%" }}>
        <thead>
          <tr>
            <th
              style={{
                padding: "8px",
                borderBottom: "2px solid #ddd",
                textAlign: "left",
              }}
            >
              Smileys
            </th>
            <th
              style={{
                padding: "8px",
                borderBottom: "2px solid #ddd",
                textAlign: "left",
              }}
            >
              Stroomsnelheid ({unitName})
            </th>
            <th
              style={{
                padding: "8px",
                borderBottom: "2px solid #ddd",
                textAlign: "left",
              }}
            >
              Beschrijving
            </th>
          </tr>
        </thead>
        <tbody>
          {smileyData.map(({ smileys, range, description }, index) => (
            <tr
              key={index}
              style={{ backgroundColor: index % 2 ? "#f9f9f9" : "#fff" }}
            >
              <td style={{ padding: "8px", borderBottom: "1px solid #eee" }}>
                <UnicodeSmileyFont smiley={smileys} />
              </td>
              <td style={{ padding: "8px", borderBottom: "1px solid #eee" }}>
                {toConvertedString(range[0])} / {toConvertedString(range[1])}
              </td>
              <td style={{ padding: "8px", borderBottom: "1px solid #eee" }}>
                {description}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default SmileyStromingTable;
